module.exports = __webpack_public_path__ + "img/overview_icon.f5d113f8.svg";